import { render, staticRenderFns } from "./addgiftBag.vue?vue&type=template&id=7a958392&scoped=true&"
import script from "./addgiftBag.vue?vue&type=script&lang=js&"
export * from "./addgiftBag.vue?vue&type=script&lang=js&"
import style0 from "./addgiftBag.vue?vue&type=style&index=0&id=7a958392&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a958392",
  null
  
)

export default component.exports